import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PowerUpDirectoryCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PowerUpDirectoryCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluginCategories"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PowerUpDirectoryCategories","document":PowerUpDirectoryCategoriesDocument}} as const;
export type PowerUpDirectoryCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PowerUpDirectoryCategoriesQuery = (
  { __typename: 'Query' }
  & Pick<Types.Query, 'pluginCategories'>
);

/**
 * __usePowerUpDirectoryCategoriesQuery__
 *
 * To run a query within a React component, call `usePowerUpDirectoryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerUpDirectoryCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerUpDirectoryCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePowerUpDirectoryCategoriesQuery(
  baseOptions?: TrelloQueryHookOptions<
    PowerUpDirectoryCategoriesQuery,
    PowerUpDirectoryCategoriesQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PowerUpDirectoryCategoriesDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PowerUpDirectoryCategoriesQuery,
    PowerUpDirectoryCategoriesQueryVariables
  >(PowerUpDirectoryCategoriesDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePowerUpDirectoryCategoriesLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PowerUpDirectoryCategoriesQuery,
    PowerUpDirectoryCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PowerUpDirectoryCategoriesQuery,
    PowerUpDirectoryCategoriesQueryVariables
  >(PowerUpDirectoryCategoriesDocument, options);
}
export function usePowerUpDirectoryCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PowerUpDirectoryCategoriesQuery,
        PowerUpDirectoryCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PowerUpDirectoryCategoriesQuery,
    PowerUpDirectoryCategoriesQueryVariables
  >(PowerUpDirectoryCategoriesDocument, options);
}
export type PowerUpDirectoryCategoriesQueryHookResult = ReturnType<
  typeof usePowerUpDirectoryCategoriesQuery
>;
export type PowerUpDirectoryCategoriesLazyQueryHookResult = ReturnType<
  typeof usePowerUpDirectoryCategoriesLazyQuery
>;
export type PowerUpDirectoryCategoriesSuspenseQueryHookResult = ReturnType<
  typeof usePowerUpDirectoryCategoriesSuspenseQuery
>;
export type PowerUpDirectoryCategoriesQueryResult = Apollo.QueryResult<
  PowerUpDirectoryCategoriesQuery,
  PowerUpDirectoryCategoriesQueryVariables
>;
